module.exports = {
  "app.copyright.produced": "Produced by AnVui",
  "common.button.batchDeletion": "Batch delete",
  "common.button.batchInactive": "Batch inactive",
  "common.button.cancel": "Cancel",
  "common.button.new": "Create new",
  "common.button.save": "Save",
  "common.button.update": "Update",
  "common.button.delete": "Delete",
  "common.button.view": "View",
  "common.button.edit": "Edit",
  "common.fields.updatedAt": "Last modified",
  "common.message.addError": "Add data failed. Please try again!",
  "common.message.addSuccess": "Add data successfully",
  "common.message.adding": "Adding...",
  "common.message.deleteError": "Delete data failed. Please try again!",
  "common.message.deleteSuccess": "Delete data successfully",
  "common.message.deleting": "Deleting...",
  "common.message.updateError": "Update data failed. Please try again!",
  "common.message.updateSuccess": "Update data successfully",
  "common.message.updating": "Updating...",
  "common.text.chosen": "Choosen",
  "common.text.item": "item",
  "common.text.operating": "Operating",
  "common.text.search": "Search",
  "modal.button.cancel": "Cancel",
  "modal.button.ok": "Ok",
  "modal.delete.title": "Do you want to delete?",
  "pages.admin.subPage.title": "This page can only be viewed by admin",
  "pages.userList.detailForm.title": "Account detail",
  "pages.userList.enums.active.false": "Inactive",
  "pages.userList.enums.active.true": "Active",
  "pages.userList.enums.gender.male": "Male",
  "pages.userList.fields.active": "Status",
  "pages.userList.fields.birthday": "Birthday",
  "pages.userList.fields.displayName": "Display name",
  "pages.userList.fields.email": "Email",
  "pages.userList.fields.firstName": "First name",
  "pages.userList.fields.gender": "Gender",
  "pages.userList.fields.lastName": "Last name",
  "pages.userList.fields.mobile": "Mobile",
  "pages.userList.fields.mobile.invalid": "Phone number is not in the correct format",
  "pages.userList.fields.password": "Password",
  "pages.userList.fields.password.required": "Please enter the password!",
  "pages.userList.fields.username": "Username",
  "pages.userList.fields.username.required": "Please enter the username!",
  "pages.userList.gender.female": "Female",
  "common.modal.changeStatus.active": "Do you want to inactive?",
  "common.modal.changeStatus.inactive": "Do you want to active?",
  "pages.userList.newForm.button.nextStep": "Next",
  "pages.userList.newForm.button.preStep": "Previous",
  "pages.userList.newForm.step1": "Account",
  "pages.userList.newForm.step2": "Information",
  "pages.userList.newForm.title": "New account",
  "pages.userList.table.title": "Account list",
  "pages.userList.tips.username": "Username is unique",
  "common.table.footer.status": "| Active: {active} | Inactive: {inactive}",
  "pages.userList.updateForm.title": "Update account",
  "pages.welcome.advancedComponent": "Advanced Form",
  "pages.welcome.advancedLayout": "Advanced layout",
  "pages.welcome.alertMessage": "Faster and stronger heavy-duty components have been released.",
  "pages.welcome.link": "Welcome",
  "pages.lhv_partner.table.title": "LHV Partner Device List",
  "pages.lhv_partner.detailForm.title": "LHV Partner Device Information",
  "pages.lhv_partner.fields.serial": "Device Code",
  "pages.lhv_partner.fields.serial.tips": "Device code is unique",
  "pages.lhv_partner.fields.deviceName": "Device Name",
  "pages.lhv_partner.fields.active": "Status",
  "pages.lhv_partner.fields.connected": "Connection",
  "pages.lhv_partner.fields.storeName": "Store Name",
  "pages.lhv_partner.fields.bankAccountNumber": "Bank Account Number",
  "pages.lhv_partner.fields.terminalID": "Terminal ID",
  "pages.lhv_partner.fields.totalTransaction": "Total Transactions",
  "pages.lhv_partner.fields.totalAmount": "Total Revenue",
  "pages.lhv_partner.fields.createdAt": "Activation Date",
  "pages.lhv_partner.status.online": "Online",
  "pages.lhv_partner.status.offline": "Offline",
  "pages.lhv_partner.modal.reset.confirm": "Are you sure you want to reset this device?",
  "common.actions.reset": "Reset Device",
  "common.actions.view": "View details",
  "common.status.active": "Active",
  "common.status.inactive": "Inactive",
  "permission.data.resource.lhv_partner": "LHV Partner Devices",
  "permission.data.resource.lhv_partner.action.view": "View device list",
  "permission.data.resource.lhv_partner.action.reset": "Reset device",
  "permission.data.resource.company.action.changeAccountBalance": "Change account balance",
  "permission.data.resource.vpbqr_terminal.action.remove": "Delete terminal",
  "permission.data.resource.vpbqr_terminal.action.update": "Update terminal information",
  "permission.data.resource.vpbqr_terminal.action.view": "View terminal list",
  "permission.data.resource.vpbqr_customer_sdk_log": "VPBankQR - Customer SDK Log",
  "permission.data.resource.vpbqr_customer_sdk_log.action.delete": "Delete log",
  "permission.data.resource.vpbqr_customer_sdk_log.action.export": "Export log to Excel",
  "permission.data.resource.vpbqr_customer_sdk_log.action.view": "View log list",
  "pages.dynamicReport.table.title": "Dynamic Reports",
  "pages.dynamicReport.table.toolbar.add": "Create Report",
  "pages.dynamicReport.fields.reportName": "Report Name",
  "pages.dynamicReport.fields.reportCode": "Report Code",
  "pages.dynamicReport.fields.status": "Status",
  "pages.dynamicReport.fields.createdAt": "Created At",
  "pages.dynamicReport.fields.updatedAt": "Updated At",
  "pages.dynamicReport.form.title": "Dynamic Report Configuration"
}
